import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import API_URL from "./config";
import "./ResetPassword.css";
import "./variables.css";
import useAuthDarkTheme from "./useAuthDarkTheme";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [characterErrors, setCharacterErrors] = useState({});

  const PASSWORD_LIMITS = { min: 8, max: 32 };

  useAuthDarkTheme();

  const navigate = useNavigate();
  const location = useLocation();

  // Get token from URL
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setCharacterErrors({});

    if (!token) {
      setError("No token found in URL.");
      return;
    }

    // Validate password length
    if (newPassword.length < PASSWORD_LIMITS.min || newPassword.length > PASSWORD_LIMITS.max) {
      setCharacterErrors({ newPassword: `Password must be between ${PASSWORD_LIMITS.min} and ${PASSWORD_LIMITS.max} characters` });
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, newPassword }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.detail || "Failed to reset password.");
      } else {
        setMessage("Password reset successful! Redirecting to login...");
        setTimeout(() => navigate("/login"), 3000);
      }
    } catch (err) {
      setError("Server error: " + (err.message || ""));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-password-wrapper">
      <h2>Reset Your Password</h2>
      <form onSubmit={handleSubmit} className="reset-password-form">
        <label>New Password</label>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          maxLength={32}
          required
        />
        {characterErrors.newPassword && <p className="character-error">{characterErrors.newPassword}</p>}
        <p className="character-hint">Password must be 8-32 characters</p>

        <label>Confirm New Password</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? "Resetting..." : "Reset Password"}
        </button>
      </form>

      {error && <p className="error-message">{error}</p>}
      {message && <p className="success-message">{message}</p>}
    </div>
  );
};

export default ResetPassword;